import { CONFIG } from '@frameio/config';
import { identify as datadogIdentify } from './datadog';
import type { IdentifyOptions, TelemetryIdentity } from './types';

export function identify(
  identity: TelemetryIdentity,
  options?: IdentifyOptions
) {
  const { telemetryOptions } = CONFIG.thirdParty;

  const fullIdentity: TelemetryIdentity = { id: identity.id };
  if (identity.accountId) {
    fullIdentity.accountId = identity.accountId;
  }
  if (telemetryOptions?.attachUserEmail) {
    fullIdentity.email = identity.email;
  }

  datadogIdentify(fullIdentity, options);
}

export function unidentify() {
  if (typeof window !== 'undefined') {
    window.analytics?.reset();
  }
}
